import { DAYS, POSTS } from "@/pages/allAnalytics/constants";
import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils";

export const pinterestFollowersGrowthConfig = [
    {
        plotName: "growth",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.followers",
        helpText: "analytics_growth.total_number_of_followers_pinterest",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "growth",
        metricName: "followers",
        sumMetrics: false,
        title: "analytics_growth.new_followers",
        helpText: "analytics_growth.users_who_followed_you_recently_pinterest",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]

export const pinterestPlatformsGrowthConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_pinterest",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "engagement",
        metricName: "engagement",
        sumMetrics: false,
        title: "analytics_growth.engagement",
        helpText: "analytics_growth.total_number_of_engagements_pinterest",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "growth",
        metricName: "pin_clicks",
        sumMetrics: false,
        title: "analytics_growth.pin_clicks",
        helpText: "analytics_growth.total_number_of_pin_clicks_pinterest",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "growth",
        metricName: "page_visits",
        sumMetrics: false,
        title: "analytics_growth.page_visits",
        helpText: "analytics_growth.total_number_of_page_visits_pinterest",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
    }
]

export const pinterestPlatformsVideoConfig = [


    {
        plotName: "video",
        metricName: "video_10s_view",
        sumMetrics: false,
        title: "analytics_growth.video_10s_view",
        helpText: "analytics_growth.total_number_of_10s_video_views_pinterest",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "video",
        metricName: "video_avg_watch_time",
        sumMetrics: false,
        title: "analytics_growth.video_avg_watch_time",
        helpText: "analytics_growth.total_number_of_avg_watch_time_pinterest",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "video",
        metricName: "video_mrc_view",
        sumMetrics: false,
        title: "analytics_growth.video_mrc_view",
        helpText: "analytics_growth.total_number_of_mrc_views_pinterest",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "video",
        metricName: "video_v50_watch_time",
        sumMetrics: false,
        title: "analytics_growth.video_v50_watch_time",
        helpText: "analytics_growth.total_number_of_v50_watch_time_pinterest",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
    }
]

export const pinterestPlatformsGrowthPerDayConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_pinterest",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    },
    {
        plotName: "engagement",
        metricName: "engagement",
        sumMetrics: false,
        title: "analytics_growth.engagement",
        helpText: "analytics_growth.total_number_of_engagements_pinterest",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    },
    {
        plotName: "growth",
        metricName: "pin_clicks",
        sumMetrics: false,
        title: "analytics_growth.pin_clicks",
        helpText: "analytics_growth.total_number_of_pin_clicks_pinterest",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    },
    {
        plotName: "growth",
        metricName: "page_visits",
        sumMetrics: false,
        title: "analytics_growth.page_visits",
        helpText: "analytics_growth.total_number_of_page_visits_pinterest",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
        divideBy: DAYS,
    }
]




export const pinterestPlatformsGrowthPerPostConfig = [


    {
        plotName: "growth",
        metricName: "impressions",
        sumMetrics: false,
        title: "analytics_growth.impressions",
        helpText: "analytics_growth.total_number_of_impressions_pinterest",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
    {
        plotName: "engagement",
        metricName: "engagement",
        sumMetrics: false,
        title: "analytics_growth.engagement",
        helpText: "analytics_growth.total_number_of_engagements_pinterest",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
    {
        plotName: "growth",
        metricName: "pin_clicks",
        sumMetrics: false,
        title: "analytics_growth.pin_clicks",
        helpText: "analytics_growth.total_number_of_pin_clicks_pinterest",
        cssIcon: "fa-duotone fa-solid fa-bullhorn",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    },
    {
        plotName: "growth",
        metricName: "page_visits",
        sumMetrics: false,
        title: "analytics_growth.page_visits",
        helpText: "analytics_growth.total_number_of_page_visits_pinterest",
        cssIcon: "fa-duotone fa-solid fa-heart",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,

        calculateFunction: getsumOfValues,
        divideBy: POSTS,
    }
]
